import React from 'react';

import AvatarGroup from 'components/shared/AvatarGroup/AvatarGroup';
import Checkbox from 'components/shared/Checkbox/Checkbox';

const OnboardingDetailRenderer = React.memo(({ data, context }) => {
  const handleSubstepClick = (e, substep) => {
    if (e.target.closest('[data-suppress-delegate-click]')) return;
    context.onDelegateRow?.(data, substep);
  };

  const handleKeyDown = (e, substep) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleSubstepClick(e, substep);
    }
  };

  return (
    <div role="gridcell" onClick={(e) => e.stopPropagation()} className="!max-h-fit">
      <div className="h-fit bg-[#FAFAFA]">
        {data.substeps.map((substep) => {
          const assignments = substep.assignments || [];
          const items = assignments.map((a) => ({
            id: a.user_id,
            fullName: a.first_name + ' ' + a.last_name
          }));
          const isSingleUser = assignments.length === 1;
          const label = isSingleUser ? items[0].fullName : null;

          return (
            <div
              key={substep.code}
              role="button"
              tabIndex={0}
              onClick={(e) => handleSubstepClick(e, substep)}
              onKeyDown={(e) => handleKeyDown(e, substep)}
              className="flex h-[50px] cursor-pointer items-center border-0 border-b border-solid border-[#E9EAEB] pl-[24px] hover:bg-[#F0F9FF]">
              <div
                className="flex w-[82px] min-w-[82px] max-w-[82px] items-center"
                data-suppress-delegate-click>
                <Checkbox
                  id={`substep-checkbox-${substep.code}`}
                  label=""
                  size={16}
                  onChange={() => context.onToggleDetail(substep.code, data.node)}
                  isChecked={substep.checked}
                />
              </div>
              <div className="flex flex-1 items-center">
                <span>{substep.name}</span>
              </div>
              <div className="flex flex-1 items-center pl-4 [&_p]:!font-normal">
                {assignments.length > 0 ? (
                  <AvatarGroup label={label} isCompact itemsToShow={5} items={items} />
                ) : (
                  '-'
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});

OnboardingDetailRenderer.displayName = 'OnboardingDetailRenderer';

export default OnboardingDetailRenderer;
